import { render, staticRenderFns } from "./delToast.vue?vue&type=template&id=40779cef&"
import script from "./delToast.vue?vue&type=script&lang=js&"
export * from "./delToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports